/**
 * React Query DevTools
 * 
 * Lazy-loaded React Query DevTools for development
 */

import { lazy, Suspense } from 'react';

const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools,
  }))
);

export function DevTools() {
  // Only show in local development (localhost)
  const isLocalhost = 
    typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || 
     window.location.hostname === '127.0.0.1' ||
     window.location.hostname === '');

  // Hide in production and non-localhost environments (dev, staging, etc.)
  if (process.env.NODE_ENV === 'production' || !isLocalhost) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ReactQueryDevtoolsProduction />
    </Suspense>
  );
}
